import { NextPrevChartNames } from '~/utils/types/dashboard';
import ArrowLeft from '~/components/Dashboard/images/arrow-left.svg?react';
import ArrowRight from '~/components/Dashboard/images/arrow-right.svg?react';
import styles from './NextPrevChartBtn.module.scss';

interface INextPrevDataLoadBtnProps {
  page: number;
  totalPages?: number;
  isLoading: boolean;
  isCurrentData: boolean;
  onClick: (value: NextPrevChartNames) => void;
}

export const NextPrevDataLoadBtn = ({
  page,
  totalPages,
  isLoading,
  isCurrentData,
  onClick,
}: INextPrevDataLoadBtnProps) => {
  return (
    <div className={styles.arrowButtons}>
      <button
        disabled={page <= 1 || isLoading || isCurrentData}
        className={styles.arrowButton}
        onClick={() => onClick(NextPrevChartNames.PREV)}
      >
        <ArrowLeft />
      </button>
      <button
        disabled={
          (!!totalPages && totalPages <= page) || isLoading || isCurrentData
        }
        className={styles.arrowButton}
        onClick={() => onClick(NextPrevChartNames.NEXT)}
      >
        <ArrowRight />
      </button>
    </div>
  );
};
